import React, { useEffect, useState } from 'react'
import { CleanupConfirmDialog, CleanupIntroDialog } from './CleanupDialogs'
import { startCleanupSession } from '../../utils/localReset/cleanupSession'
import { readDownloadedFarmsCount } from '../../observability/footprint'

const defaultLoadPending = async () => {
  const [{ getPendingSummary }, { default: database }] = await Promise.all([
    import('../../utils/pendingData'),
    import('../../database'),
  ])
  return getPendingSummary(database)
}

// Diálogos 1 e 2 (Dec. 8). Confirmar inicia a sessão de limpeza (fora do React) e se fecha; o
// CleanupResumeGate passa a mostrar o overlay no lugar do app.
export default function CleanupFlow({
  onClose,
  startSession = startCleanupSession,
  readFarmsCount = readDownloadedFarmsCount,
  loadPending = defaultLoadPending,
}) {
  const [stage, setStage] = useState('intro')
  const [pending, setPending] = useState({ loading: true })

  useEffect(() => {
    if (stage !== 'confirm') return undefined
    let alive = true
    setPending({ loading: true })
    loadPending()
      .then(
        (s) =>
          alive &&
          setPending({
            loading: false,
            unreadable: s.unreadable.length > 0,
            dirtyRecords: s.dirtyRecords,
            eventsUnsent: s.eventsUnsent,
          }),
      )
      .catch(() => alive && setPending({ loading: false, unreadable: true }))
    return () => {
      alive = false
    }
  }, [stage, loadPending])

  return (
    <>
      <CleanupIntroDialog
        open={stage === 'intro'}
        onCancel={onClose}
        onContinue={() => setStage('confirm')}
      />
      <CleanupConfirmDialog
        open={stage === 'confirm'}
        farmsCount={readFarmsCount() ?? 0}
        pending={pending}
        onCancel={onClose}
        onConfirm={() => {
          startSession()
          onClose()
        }}
      />
    </>
  )
}
